import { API_ENDPOINT } from 'utils/constants';
import { submit } from 'utils/proxy';

const droplistService = {
  getBloodTypeDL,
  getCountryDL,
  getGenderDL,
  getRaceDL,
  getReligionDL,
  getNationalityDL,
};

function getBloodTypeDL(){
  return submit('GET', `${API_ENDPOINT}/api/v1/blood_type/droplist`, {}, {});
};

function getCountryDL(){
  return submit('GET', `${API_ENDPOINT}/api/v1/country/droplist`, {}, {});
};

function getGenderDL(){
  return submit('GET', `${API_ENDPOINT}/api/v1/gender/droplist`, {}, {});
}

function getRaceDL(){
  return submit('GET', `${API_ENDPOINT}/api/v1/race/droplist`, {}, {});
}

function getReligionDL(){
  return submit('GET', `${API_ENDPOINT}/api/v1/religion/droplist`, {}, {});
}

function getNationalityDL(){
  return submit('GET', `${API_ENDPOINT}/api/v1/nationality/droplist`, {}, {});
}

export default droplistService;
